import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material';

// openDialogWithAResult
@Component({
    selector: 'confirm-deleteLocation-dialog',
    template: `<h4 md-dialog-title>Warning!</h4>
  <div md-dialog-content style="padding-bottom: 20px;">Customer with same company name already exist. <br> Do you want to continue creating?</div>
  <div md-dialog-actions>
    <button mat-button (click)="dialogRef.close('cancel')">No</button>
    <button mat-button (click)="dialogRef.close('confirm')">Yes</button>
  </div>`,
})
export class ConfirmCreateCustomerWithExistingNameComponent {
    constructor(public dialogRef: MatDialogRef<ConfirmCreateCustomerWithExistingNameComponent>) {}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/customers/home/ConfirmCreateCustomerWithExistingNameComponent.ts